// projects/pwa/src/ach/tax-payments/containers/tax-template-workflow-container.data.ts
export const TAX_TEMPLATE_WORKFLOW_CONTAINER_TAG_NAME = 'tax-template-workflow-container';
